"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useReportExports = void 0;
const react_1 = require("react");
const event_callback_hook_1 = require("../../../utils/event-callback-hook");
const reporting_types_1 = require("../reporting-types");
const table_cells_1 = require("../../../composite/table/table-cells");
function useReportExports({ report, definition, }) {
    const exportDialogRef = react_1.useRef(null);
    const openExportDialog = event_callback_hook_1.useEventCallback(() => { var _a; return (_a = exportDialogRef.current) === null || _a === void 0 ? void 0 : _a.open(); });
    const closeExportDialog = event_callback_hook_1.useEventCallback(() => { var _a; return (_a = exportDialogRef.current) === null || _a === void 0 ? void 0 : _a.close(); });
    const provideData = event_callback_hook_1.useEventCallback(() => {
        if (definition != null && report != null) {
            return {
                title: definition.label,
                definitionId: definition.id,
                columns: serializeReportColumns(report.columns),
            };
        }
        else {
            return {};
        }
    });
    return {
        exportDialogRef,
        openExportDialog,
        closeExportDialog,
        provideData,
    };
}
exports.useReportExports = useReportExports;
function serializeReportColumns(columns) {
    return columns.map((column) => {
        var _a;
        const CellComponent = getCellComponent(column);
        const valueMapperName = column.type === reporting_types_1.ReportColumnType.SELECT
            ? 'selectColumnMapper'
            : undefined;
        const valueMapperData = column.type === reporting_types_1.ReportColumnType.SELECT ? column.selectItems : undefined;
        return {
            name: column.name,
            datakey: column.datakey,
            displaykey: column.datakey,
            width: column.width,
            visible: true,
            cellComponentName: (_a = CellComponent.displayName) !== null && _a !== void 0 ? _a : CellComponent.name,
            valueMapperName,
            valueMapperData,
        };
    });
}
function getCellComponent(column) {
    switch (column.type) {
        case reporting_types_1.ReportColumnType.TEXT:
            return table_cells_1.TableCells.TextCell;
        case reporting_types_1.ReportColumnType.NUMBER:
            return table_cells_1.TableCells.NumberCell;
        case reporting_types_1.ReportColumnType.BOOLEAN:
            return table_cells_1.TableCells.BooleanCell;
        case reporting_types_1.ReportColumnType.DATE:
            return table_cells_1.TableCells.DateCell;
        case reporting_types_1.ReportColumnType.DATETIME:
            return table_cells_1.TableCells.DateTimeCell;
        case reporting_types_1.ReportColumnType.TIME:
            return table_cells_1.TableCells.TimeCell;
        case reporting_types_1.ReportColumnType.SELECT:
            return table_cells_1.TableCells.TextCell;
    }
}
//# sourceMappingURL=export-hook.js.map